import { render, staticRenderFns } from "./TextStatement.vue?vue&type=template&id=7f720272&scoped=true&"
import script from "./TextStatement.vue?vue&type=script&lang=js&"
export * from "./TextStatement.vue?vue&type=script&lang=js&"
import style0 from "./TextStatement.vue?vue&type=style&index=0&id=7f720272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f720272",
  null
  
)

export default component.exports